import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { settings } from "../config/settings";

const loadGAScript = (trackingId) => {
  if (
    !document.querySelector(
      `script[src="https://www.googletagmanager.com/gtag/js?id=${trackingId}"]`,
    )
  ) {
    const script = document.createElement("script");
    script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
    script.async = true;
    document.head.appendChild(script);

    script.onload = () => {
      globalThis.dataLayer = globalThis.dataLayer || [];
      function gtag() {
        globalThis.dataLayer.push(arguments);
      }
      globalThis.gtag = gtag;
      gtag("js", new Date());
      gtag("config", trackingId);
    };
  }
};

const usePageViews = () => {
  const location = useLocation();

  useEffect(() => {
    const trackingId = settings.googleAnalyticsToken;

    if (trackingId) {
      loadGAScript(trackingId);

      if (globalThis.gtag) {
        globalThis.gtag("config", trackingId, {
          page_path: location.pathname,
        });
      }
    }
  }, [location]);
};

export default usePageViews;
